import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9y6fjby6et: FaireBrandEntity = {
  token: "b_9y6fjby6et",
  type: "brand",
  name: "Raincoast Distribution Group",
  avatarUrl:
    "https://cdn.faire.com/fastly/62196dbecd10cfd5fbfe292bfb36ceba251f361b6f9ea7efc8251f845b4642f4.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d5efd9fc13f0b99f753b2b3c2c81bb48764be732a6fc61d65c7816464fd61f20.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/62196dbecd10cfd5fbfe292bfb36ceba251f361b6f9ea7efc8251f845b4642f4.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d5efd9fc13f0b99f753b2b3c2c81bb48764be732a6fc61d65c7816464fd61f20.jpeg",
  location: "Richmond, BC, CAN",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 11,
  isInsider: false,
  description:
    "Raincoast Book Distribution (RDG): Founded in Vancouver in 1979 and proudly Canadian, RDG is the largest domestically owned book distributor in the country. RDG is made up of two full-service sales and marketing distribution divisions; Raincoast Books in Richmond and Publishers Group Canada (PGC) in Toronto, along with Book Express, a wholesale division that drives our customer service standard.  Product from all three divisions is handled by the largest book distributor or publisher  warehouse in Canada and a single Systems, customer service and back office support team.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T14:51:00.477Z",
    importedBy: "entity-db-cli",
  },
};
